"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function DefaultImageThumSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 112, height: 77, viewBox: "0 0 112 77", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("rect", { x: 13, y: 15, width: 85.1485, height: 47.4603, fill: "#597EFF", fillOpacity: 0.1 }),
        react_1.default.createElement("path", { opacity: 0.2, fillRule: "evenodd", clipRule: "evenodd", d: "M49.5527 34.6035C50.6167 34.6035 51.4793 33.6797 51.4793 32.5401C51.4793 31.4004 50.6167 30.4766 49.5527 30.4766C48.4886 30.4766 47.626 31.4004 47.626 32.5401C47.626 33.6797 48.4886 34.6035 49.5527 34.6035ZM58.0305 33.0566L64.4849 45.9535H51.5762L51.5762 45.9534H46.6631L51.6243 35.9688L54.0898 40.9308L58.0305 33.0566Z", fill: "#597EFF" }));
}
function DefaultImageThum(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(DefaultImageThumSvg, Object.assign({}, svgProps)));
}
exports.default = DefaultImageThum;
//# sourceMappingURL=DefaultImageThum.js.map